module.exports = __webpack_public_path__ + "static/media/Story-Research-Photo 2.b45476a3.jpg";